<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div class="initial-empty-container">     
        <img
          alt=""
          class="axis-img-responsive _mlr-auto"
          src="assets/images/messages/no-data-available.svg"
          />
          @if (isJp=== true) {
            <div class="axis-title">現在、サービスを停止しております</div>
            <p>ご迷惑をお掛けして申し訳ございません。</p>
          }

          @if (isJp !== true) {
            <div class="axis-title" i18n="@@service1">Service Unavailable</div>
            <p  i18n="@@service2">The service is currently unavailable. We apologize for the inconvenience. Please try again later.</p>
          }
          
    </div>
  </div>
</div>
